import { createConfirmation } from "react-confirm";
import AddVideoListDialog from "./AddVideoListPage";

export const showAddVideoListDialog = createConfirmation(AddVideoListDialog);
